var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2,18.5h-6.3c-1.1,0-1.6,0-2.2-.3-.5-.3-.9-.7-1.2-1.2-.3-.6-.3-1.2-.3-2.2V5.2c0-1.1,0-1.6.3-2.2.3-.5.7-.9,1.2-1.2.6-.3,1.2-.3,2.2-.3h4s0,0,0,0c.3,0,.5,0,.8,0,.3,0,.5.2.8.3.3.2.5.4.8.7l2.6,2.6c.3.3.5.5.7.8.1.2.3.5.3.8,0,.2,0,.5,0,.8h0v7.4c0,1.1,0,1.6-.3,2.2-.3.5-.7.9-1.2,1.2-.6.3-1.2.3-2.2.3ZM6.8,3.5c-.6,0-1.2,0-1.3,0-.1,0-.2.2-.3.3,0,.1,0,.7,0,1.3v9.7c0,.6,0,1.2,0,1.3,0,.1.2.2.3.3.1,0,.7,0,1.3,0h6.3c.6,0,1.2,0,1.3,0,.1,0,.2-.2.3-.3,0-.1,0-.7,0-1.3v-6.3h-1.3c-1.1,0-1.6,0-2.2-.3-.5-.3-.9-.7-1.2-1.2-.3-.6-.3-1.2-.3-2.2v-1.3h-3ZM11.8,4.1v.8c0,.6,0,1.2,0,1.3,0,.1.2.2.3.3.1,0,.7,0,1.3,0h.8l-2.4-2.4ZM10,16h0c0,0-.2,0-.3,0,0,0-.1,0-.2,0,0,0,0,0-.1,0l-2.5-1.7c-.5-.3-.6-.9-.3-1.4.3-.5.9-.6,1.4-.3l.9.6v-3.1c0-.6.4-1,1-1s1,.4,1,1v3.1l.9-.6c.5-.3,1.1-.2,1.4.3.3.5.2,1.1-.3,1.4l-2.5,1.7s0,0-.1,0c0,0-.1,0-.2,0,0,0-.2,0-.3,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/File_Download.ec8a9352fa0cdd07e6659d81c92b67f0.svg";
export { ForwardRef as ReactComponent };